import { DataService } from '../dataService';

export const bookContextService = {
  create: async (data) => {
    try {
      const response = await DataService.post(`book-context`, data, { 'Content-Type': 'multipart/form-data' });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getContext: async (content_id) => {
    try {
      const response = await DataService.get(`book-context/${content_id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  deleteContext: async (context_id) => {
    try {
      const response = await DataService.delete(`book-context/${context_id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
